import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface FamilyCardMember {
  full_name: string;
  patient_number: string;
  age?: number | null;
  contact_number?: string | null;
}

export interface FamilyCardMatch {
  id: number;
  number: string;
  patient_count: number;
  patients: FamilyCardMember[];
}

export interface PendingRegistration {
  id: number;
  salutation?: string | null;
  full_name: string;
  age?: number | null;
  age_months?: number | null;
  age_days?: number | null;
  contact_number: string;
  email?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
  occupation?: string | null;
  status: 'pending' | 'approved' | 'rejected';
  patient_id?: number | null;
  rejection_reason?: string | null;
  created_at?: string;
  reviewed_at?: string | null;
  family_matches?: FamilyCardMatch[];
}

@Injectable({
  providedIn: 'root',
})
export class PendingRegistrationService {
  private readonly apiUrl: string;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private authHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
    };
  }

  list(status: string = 'pending', search: string = '', page: number = 1, per_page: number = 15): Observable<{
    success: boolean;
    data: PendingRegistration[];
    pagination?: { total: number; per_page: number; current_page: number; last_page: number };
    pending_count: number;
  }> {
    const params: any = { status, page, per_page };
    if (search) {
      params.search = search;
    }
    return this.http.get<{ 
      success: boolean; 
      data: PendingRegistration[]; 
      pagination?: { total: number; per_page: number; current_page: number; last_page: number };
      pending_count: number; 
    }>(
      `${this.apiUrl}/pending-registrations`,
      { ...this.authHeaders(), params }
    );
  }

  approve(id: number, overrides: Record<string, any> = {}): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/pending-registrations/${id}/approve`,
      overrides,
      this.authHeaders()
    );
  }

  reject(id: number, reason?: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/pending-registrations/${id}/reject`,
      { reason: reason || null },
      this.authHeaders()
    );
  }
}
